// Captures the beforeinstallprompt event synchronously at module load time,
// before React mounts. This is required because Chrome fires the event early
// in the page lifecycle — before any useEffect can attach a listener.
//
// Import this module as the FIRST import in index.js.

let _prompt = null;
const listeners = new Set();

function notifyPromptListeners() {
  listeners.forEach((listener) => {
    listener(_prompt);
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    _prompt = e;
    notifyPromptListeners();
  });
}

export function getInstallPrompt() {
  return _prompt;
}

export function clearInstallPrompt() {
  _prompt = null;
  notifyPromptListeners();
}

export function subscribeInstallPrompt(listener) {
  listeners.add(listener);
  listener(_prompt);
  return () => listeners.delete(listener);
}
